import {EventSummary, fromTimestamp} from "../drinkService";
import { Event as DrinkEvent, EventList } from "../../generated/drinks_pb";

const mapEvent = (event: DrinkEvent): EventSummary => {
    const startTs = event.getTshappeningstart();
    const endTs = event.getTshappeningend();
    return {
        eventId: event.getEventid(),
        eventName: event.getEventname(),
        location: event.getLocation(),
        start: startTs ? fromTimestamp(startTs) : null,
        end: endTs ? fromTimestamp(endTs) : null,
        ownerUserId: event.getOwneruserid(),
        isActive: event.getIsactive(),
        visibility: event.getVisibility(),
        requiresPassword: event.getRequirespassword(),
        isParticipant: event.getIsparticipant(),
    };
};

const mapEventList = (list: EventList): EventSummary[] => list.getEventsList().map(mapEvent);

export {mapEvent, mapEventList};
